





































































import {Vue, Component} from "vue-property-decorator";

import axios from 'axios'

@Component({})
export default class App extends Vue {
  private drawer = false

  get title(): String {
    return this.$store.getters.title
  }

  created() {
    let userString = localStorage.getItem('user')
    if (userString && userString !== 'undefined') {
      const userData = JSON.parse(userString)
      this.$store.commit('SET_USER_DATA', userData)
    } else {
      this.$router.push({name: 'Login'})
    }
    axios.interceptors.response.use(
        response => response,
        error => {
          if (error.response.status === 401 &&
              this.$router.currentRoute.name != 'Login') {
            this.logout()
          }
          return Promise.reject(error)
        }
    )
  }

  logoClick() {
    this.$router.push({name: 'Sites'})
  }

  logout() {
    this.$router.push({name: 'Login'})
    this.$store.dispatch('logout')
  }
}
